// extracted by mini-css-extract-plugin
module.exports = {"background":"ch","white":"ci","black":"cj","grey":"ck","container":"cl"};